import { Resources, useResource } from "Translations/Resources";
import { IconButton, Tooltip, Box, Typography } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Link } from "Navigation/Link";
import { appUrl } from "Utils/UrlUtils";

const RESOURCES = Resources.Admin.Campaigns.Table;

type NameCellProps = {
  name: string;
  code: string;
  color?: string | null;
};

export const NameCell = ({ name, code, color }: NameCellProps) => {
  const { t } = useResource();

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Tooltip title={t(RESOURCES.ViewCampaign)}>
        <IconButton
          component={Link}
          to={`${appUrl("campaign")}/${code}`}
          size="small"
          target="_blank"
          rel="noopener noreferrer"
          sx={{ padding: 0.5, color: color || undefined }}
        >
          <OpenInNewIcon fontSize="small" />
        </IconButton>
      </Tooltip>
      <Typography variant="body2">{name}</Typography>
    </Box>
  );
};
